import BadgeSB from '@/components/atoms/badge/BadgeSB';
import { HeaderItemLevel } from '@/components/atoms/layout/header/HeaderSB';
import LinkButton from '@/components/atoms/linkButton';
import { transformFromCMSLink } from '@/components/atoms/linkButton/LinkSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { PricePer } from '@/features/shared/PricePer';

interface MobileHeaderNavItemSBProps {
  menuLinkItem: HeaderItemLevel<any>;
}

export default function MobileHeaderNavItemSB({
  block,
}: BlockComponentModel<MobileHeaderNavItemSBProps>) {
  const { menuLinkItem } = block;

  return (
    <div>
      {menuLinkItem?.customLink ? (
        menuLinkItem?.customLink
      ) : (
        <LinkButton
          {...transformFromCMSLink(menuLinkItem.link)}
          variant='text'
          slim
          underline={false}
          color='tertiary'
          classNames={{ root: 'group' }}
        >
          <div className='flex flex-row items-center gap-9'>
            <div className='flex flex-col gap-1'>
              <div className='flex items-center gap-2'>
                <p className='text-neutral-N00 text-wrap'>
                  {menuLinkItem.title}
                </p>
                {menuLinkItem.badge && (
                  <BadgeSB
                    block={menuLinkItem.badge}
                    inner={{ size: 's', variant: 'outlined' }}
                  />
                )}
              </div>
              {menuLinkItem.price && <PricePer {...menuLinkItem.price} />}
            </div>
          </div>
        </LinkButton>
      )}
    </div>
  );
}
